import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FileService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = environment.fileUrl.replace(/\/$/, '');

    /**
     * Fetches a file from the CDN
     */
    public getFile<T>(relativePath: string): Observable<T> {
        const url = this.buildUrl(relativePath);
        return this.http.get<T>(url);
    }

    /**
     * Fetches a binary file from the CDN
     */
    public getBinaryFile(relativePath: string): Observable<ArrayBuffer> {
        const url = this.buildUrl(relativePath);
        return this.http.get(url, { responseType: 'arraybuffer' });
    }

    private buildUrl(...segments: string[]): string {
        const path = segments
            .filter(Boolean)
            .map(segment => segment.replace(/^\/+|\/+$/g, ''))
            .join('/');

        return `${this.baseUrl}/${path}`;
    }
}
